<template>
  <form v-on:submit="create" method="post">
    <div class="row">
      <div class="col-md-12">
        <LabelRequiredField label="Nome" />
        <input
          type="text"
          ref="autofocus"
          v-model="name"
          class="form-control"
        />
      </div>
      <div class="col-md-12">
        <label>Descrição</label>
        <input type="text" v-model="description" class="form-control" />
      </div>
      <div class="col-md-12 pt-0">
        <WarningRequiredFields />
      </div>
      <div class="col-md-12 pt-0 pb-0"><ErrorsMessages :errors="errors" /></div>
      <div class="col-md-12 text-right">
        <v-btn :disabled="loading" type="submit" class="btn-save">
          <i class="fas fa-save mr-2 text-twenty"></i>
          {{ loading ? "Carregando" : "SALVAR" }}
        </v-btn>
      </div>
    </div>
  </form>
</template>

<script>
import ErrorsMessages from "../Components/ErrorsMessages";
import WarningRequiredFields from "../Components/WarningRequiredFields";
import LabelRequiredField from "../Components/LabelRequiredField";

import api from "../../services/api";

import toast from "../../lib/ToastNotification";

export default {
  name: "Create",

  components: {
    ErrorsMessages,
    LabelRequiredField,
    WarningRequiredFields,
  },

  data() {
    return {
      name: "",
      description: "",
      loading: false,
      errors: [],
    };
  },

  created() {
    this.retrieve();
  },

  methods: {
    async retrieve() {
      this.name = "";
      this.description = "";
      this.errors = [];
      setTimeout(() => this.$refs.autofocus.focus(), 10);
    },

    async create(event) {
      try {
        event.preventDefault();
        this.loading = true;

        const { name, description } = this;

        let params = { name, description };

        const response = await api.post("/rest-home/group", params);

        const { error, errors, message } = response.data;

        if (!error) {
          this.$bvModal.hide("create");
          toast(message, "success");
          this.$emit("success");
        } else {
          this.errors = errors;
        }
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
